/**
 * React Query Provider
 * 
 * Main provider component that wraps the application with QueryClientProvider
 */

import { type QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { DevTools } from './devtools';

interface ReactQueryProviderProps {
  children: ReactNode;
  queryClient: QueryClient;
}

export function ReactQueryProvider({ children, queryClient }: ReactQueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <DevTools />
    </QueryClientProvider>
  );
}

export { getQueryClient } from './context';
export * from './types';
